import React, { useState } from 'react';
import { X } from 'lucide-react';
import { GALLERY } from '../mock/data';
import useScrollReveal from '../hooks/useScrollReveal';
import Seo from '../components/Seo';

const FILTERS = ['All', 'Weddings', 'Dining', 'Events', 'Corporate', 'Venue'];

export default function Gallery() {
  const [filter, setFilter] = useState('All');
  const [lightbox, setLightbox] = useState(null);
  const items = filter === 'All' ? GALLERY : GALLERY.filter((g) => g.cat === filter);
  useScrollReveal([filter]);

  return (
    <div>
      <Seo
        title="Gallery — Weddings, Events & Dining Moments"
        path="/gallery"
        description="Explore moments at Vivamore Dining — elegant weddings, corporate events, private celebrations and rooftop dining at NU Sentral Mall, Kuala Lumpur."
        keywords="Vivamore gallery, event photos KL, wedding venue gallery, rooftop dining photos, NU Sentral Vivamore"
      />
      <section className="pt-40 pb-16 bg-ink text-center">
        <span className="text-gold-light text-xs tracking-luxe uppercase">Moments at Vivamore</span>
        <h1 className="font-display text-5xl md:text-6xl text-cream mt-5">Gallery</h1>
        <p className="text-cream/70 font-light mt-4">Elegant Weddings · Corporate Events · Private Celebrations</p>
      </section>

      <section className="py-16 md:py-24 bg-cream">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-wrap justify-center gap-2 mb-12">
            {FILTERS.map((f) => (
              <button key={f} onClick={() => setFilter(f)} className={`text-xs tracking-widest uppercase px-6 py-3 transition-all duration-300 ${filter === f ? 'bg-gold text-cream' : 'text-ink/60 hover:text-gold border border-ink/15'}`}>
                {f}
              </button>
            ))}
          </div>

          <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 [column-fill:_balance]">
            {items.map((g, i) => (
              <button
                key={`${g.img}-${i}`}
                onClick={() => setLightbox(g.img)}
                className="reveal img-hover-zoom overflow-hidden mb-4 w-full block relative group"
                style={{ transitionDelay: `${(i % 6) * 0.06}s` }}
              >
                <img src={g.img} alt={g.cat} className="w-full object-cover" />
                <div className="absolute inset-0 bg-ink/0 group-hover:bg-ink/30 transition-colors flex items-end p-5">
                  <span className="text-cream text-xs tracking-widest uppercase opacity-0 group-hover:opacity-100 transition-opacity">{g.cat}</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {lightbox && (
        <div className="fixed inset-0 z-[60] bg-ink/95 flex items-center justify-center p-6" onClick={() => setLightbox(null)}>
          <button className="absolute top-6 right-6 text-cream hover:text-gold transition-colors" onClick={() => setLightbox(null)} aria-label="Close">
            <X size={32} />
          </button>
          <img src={lightbox} alt="" className="max-w-full max-h-[85vh] object-contain animate-fade-in" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </div>
  );
}
